import React from 'react'
import { BagFill, CartFill, CreditCard, PatchCheckFill, CartPlusFill } from 'react-bootstrap-icons';
import './Form.css'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { NavItem } from 'react-bootstrap';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { borders } from '@mui/system';



const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

export default function Form() {
    const cartItems = useSelector(state => state.cartReducer.cartItems);
    const Total = useSelector(state => state.cartReducer.total);
    if(Total == 0){
      return(
        <div className='my-5'>
        <hr className='my-5' style={{visibility: "hidden"}}></hr>
        <div className='my-5'
         style={{display: "flex",flexDirection: "column",justifyContent: "center", alignItems: "center",padding: "4%",color: "white"}}>
          <CartPlusFill style={{fontSize: "5rem", color: "green"}}></CartPlusFill>
          <h1 className='my-3'>Your Cart is empty</h1>
          <h3>Make yourself Happy by purchasing Something</h3>
          <Link to='/shop' className='btn newsletter-btn my-3'>Continue Shopping</Link>
        </div>
        </div>
      )
    }
  return (
    <div className='row formJsRow my-5 col-md-12'>
        <hr style={{visibility: "hidden"}}></hr>
        <div className="section col-12 col-md-2" style={{alignItems: "flex-start",paddingTop: "10%"}}>
        <div className="content CartIcons">
        <div className="container">
      <div className="circleIcons">
        <p style={{ display: "flex", alignItems: "center", fontSize: "1.5rem"  }} className="p-3">
            <PatchCheckFill style={{ color: "white" }} ></PatchCheckFill>
          </p>
      </div>
      <div className="lineIcons"></div>
      <div className="circleIcons">
          <p style={{ display: "flex", alignItems: "center", fontSize: "1.5rem",  }} className="p-3" >
            <CartFill style={{ color: "white" }}></CartFill>
          </p>
      </div>
      <div className="lineIcons"></div>
      <div className="circleIcons">
          <p style={{ display: "flex", alignItems: "center", fontSize: "1.5rem" }} className="p-3">
            <CreditCard style={{ color: "white" }}></CreditCard>
          </p>
      </div>
    </div>
        </div>
        </div>
        <form className="row g-3 col-md-6 border border-dark  my-1 mx-1 checkOutDetailForm" style={{color: "white"}}>
  <div className="col-md-6">
    <label htmlFor="inputEmail4" className="form-label">First Name:</label>
    <input type="First-Name" className="form-control"
     id="inputEmail4" placeholder="First Name"/>
  </div>
  <div className="col-md-6">
    <label htmlFor="inputPassword4" className="form-label">Last Name:</label>
    <input type="Last-Name" className="form-control" 
    id="inputPassword4" placeholder="Last Name"/>
  </div>
  <div className="col-12">
    <label htmlFor="inputAddress" className="form-label">Email Address:</label>
    <input type="text" className="form-control" 
    id="inputAddress" placeholder="abc@email.com"/>
  </div>
  <div className="col-12">
    <label htmlFor="inputAddress2" className="form-label">Address: </label>
    <input type="text" className="form-control" 
    id="inputAddress2" placeholder="Address"/>
  </div>
  <div className="col-md-6">
    <label htmlFor="inputCity" className="form-label">City:</label>
    <input type="text" className="form-control" id="inputCity" placeholder="City"/>
  </div>
  <div className="col-md-6">
    <label htmlFor="inputCity" className="form-label">State:</label>
    <input type="text" className="form-control" id="inputCity" placeholder="Province"/>
  </div>
  <div className="col-md-6">
    <label htmlFor="inputCity" className="form-label">Country:</label>
    <input type="text" className="form-control" id="inputCity" placeholder="Country"/>
  </div>
  
  <div className="col-md-6">
    <label htmlFor="inputZip" className="form-label">Postal Code:</label>
    <input type="text" className="form-control" id="inputZip"/>
  </div>
      <div className='col-md-12'>
        <input style={{backgroundColor: "black"}} type='checkbox'></input>
        <label>I Agree to Terms and Policy</label>
      </div>
  <div className="col-12">
    <button type="submit" className="btn newsletter-btn">Pay Now</button>
  </div>
</form>
    <div className=' col-12 col-md-3'>
    <Card sx={{ minWidth: 275,backgroundColor: "rgba(40,40,40,0.5)",color: "white",margin: "4%",borderRadius: '10%'}}>
      <CardContent>
        <Typography variant="h5" component="div">
          Your Order
        </Typography>
          {cartItems.map(item => (
            <p>
                  <tr key={item.id} style={{color: "white",display: "flex",flexDirection: "row",justifyContent: "space-between"}} >
                    <td style={{color: "white"}}>{item.title}</td>
                    <td style={{color: "white"}}>
                      {item.discountedPrice ? `$${item.discountedPrice}` : `$${item.price}`}
                      </td>
                  </tr>
            </p>
                ))}
                <p style={{display: "flex",flexDirection: "row",justifyContent: "space-between"}}
                 className='border-top'>Total: <span>{Math.round(Total)}</span></p>
      </CardContent>
    </Card>
        <Card sx={{ minWidth: 275,backgroundColor: "rgba(40,40,40,0.5)",color: "white",paddingTop: "4%",margin: "4%" ,color: "white",borderRadius: '10%',}}>
          <FormControl sx={{paddingTop: "0%",margin: "4%"}}>
          <Typography variant="h5" component="div">
            Payment Method
            </Typography>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="Master Card"
              name="radio-buttons-group"
            >
              <FormControlLabel value="Debt Card" control={<Radio />} label="Debt Card" />
              <FormControlLabel value="Payoneer" control={<Radio />} label="Payoneer" />
            </RadioGroup>
          </FormControl>
        </Card>
    </div>
    </div>
  )
}
